<div id="{{id}}" class="card {{isLight}} {{classes}}" [ngClass]="{'full-height': fullHeight}" [style.width.px]="width">
  <img *ngIf="imageSrc" class="card-img-top" src="{{imageSrc}}" alt="{{imageAlt}}">
  <ng-content></ng-content>
</div>